import Styled, { css } from 'styled-components';
import check from '@catalogo/ui-americanas-desktop-svg/check.svg';
import { CheckboxProps } from '.';

const Wrapper = Styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 6px 0 0 15px;
`;

const Text = Styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  color: #666666;
  margin-left: 8px;
`;

const Checkmark = Styled(check)<CheckboxProps>`
  cursor: pointer;
  width: 16px;
  height: 16px;
  border: 2px solid #e9e9e9;
  border-radius: 3px;
  background: #ffffff;
  fill: #ffffff;

  ${({ checked, theme }) =>
    checked &&
    css`
      background: ${theme.primaryColor};
      border-color: ${theme.primaryColor};
    `}
`;

export { Wrapper, Text, Checkmark };
